import PropTypes from 'prop-types';
import React from 'react';

import { Trans } from 'react-i18next';

import { Form, Select, Input } from '@weezevent/nacre';
import './webServices.scss';

class WebServiceForm extends React.Component {
    constructor() {
        super(...arguments);

        this.state = {
            authCode: this.props.subscription.auth_code,
            login: this.props.subscription.login,
            public_key: this.props.subscription.public_key,
            private_key: this.props.subscription.private_key,
            url: this.props.subscription.url,
            account_type: this.props.subscription.account_type,
            tenant: this.props.subscription.tenant,
            getin_url: this.props.subscription.getin_url
        };
    }

    setField(name, value) {
        return new Promise((resolve, reject) => {
            this.setState(
                {
                    [name]: value
                },
                () => {
                    this.props.onChange(this.state);
                    resolve();
                }
            );
        });
    }
}

WebServiceForm.defaultProps = {
    onChange: () => {}
};

WebServiceForm.propTypes = {
    onChange: PropTypes.func
};

class LoginPasswordService extends WebServiceForm {
    loginPasswordFields() {
        return (
            <React.Fragment>
                <Form.Field>
                    <div className="inputLabel">
                        <Trans i18nKey="ticket.webservice.form.login">Login</Trans>
                    </div>
                    <Input value={this.state.login} disabled={this.props.subscription.login !== undefined} onChange={event => this.setField('login', event.target.value)} />
                </Form.Field>
                <Form.Field>
                    <div className="inputLabel">
                        <Trans i18nKey="ticket.webservice.form.password">Password</Trans>
                    </div>
                    <Input value={this.state.password} type="password" onChange={event => this.setField('password', event.target.value)} />
                </Form.Field>
            </React.Fragment>
        );
    }

    render() {
        return this.loginPasswordFields();
    }
}

export class DigitickForm extends LoginPasswordService {
    options() {
        return;
    }

    render() {
        return (
            <React.Fragment>
                <Form.Field>
                    <label>
                        <Trans i18nKey="ticket.webservice.form.digitick_wsdl">wsdl</Trans>
                    </label>
                    <Select value={this.props.subscription.wsdl} onChange={(synth, { value }) => this.setField('wsdl', value)} options={DigitickForm.options} />
                </Form.Field>
                {this.loginPasswordFields()}
            </React.Fragment>
        );
    }
}
DigitickForm.options = [
    {
        text: 'Digitick',
        value: 'default'
    },
    {
        text: 'Seeticket',
        value: 'seetickets'
    }
];

export class FnacForm extends LoginPasswordService {}

export class UniverseForm extends WebServiceForm {
    render() {
        return (
            <Form.Field>
                <div className="inputLabel">
                    <Trans i18nKey="ticket.webservice.form.universe_auth_code">Universe Auth Code</Trans>
                </div>
                <Input
                    value={this.state.authCode}
                    onChange={event => {
                        this.setField('authCode', event.target.value);
                    }}
                />
            </Form.Field>
        );
    }
}

export class LenndForm extends WebServiceForm {
    render() {
        return (
            <Form.Field>
                <div className="inputLabel">
                    <Trans i18nKey="ticket.webservice.form.lennd_access_token">Lennd Access Token</Trans>
                </div>
                <Input
                    value={this.state.accessToken}
                    onChange={event => {
                        this.setField('accessToken', event.target.value);
                    }}
                />
            </Form.Field>
        );
    }
}

export class RegiondoForm extends WebServiceForm {
    render() {
        return (
            <React.Fragment>
                <Form.Field>
                    <div className="inputLabel">
                        <Trans i18nKey="ticket.webservice.form.regiondo_public_key">Regiondo public key</Trans>
                    </div>
                    <Input value={this.state.public_key} onChange={event => this.setField('public_key', event.target.value)} />
                </Form.Field>
                <Form.Field>
                    <div className="inputLabel">
                        <Trans i18nKey="ticket.webservice.form.regiondo_private_key">Regiondo private key</Trans>
                    </div>
                    <Input value={this.state.private_key} onChange={event => this.setField('private_key', event.target.value)} />
                </Form.Field>
            </React.Fragment>
        );
    }
}

export class SecutixForm extends LoginPasswordService {
    options() {
        return;
    }

    render() {
        return (
            <React.Fragment>
                {this.loginPasswordFields()}
                <Form.Field>
                    <div className="inputLabel">
                        <Trans i18nKey="ticket.webservice.form.secutix_url">Url</Trans>
                    </div>
                    <Input value={this.state.url} onChange={event => this.setField('url', event.target.value)} />
                </Form.Field>
            </React.Fragment>
        );
    }
}

export class TicketnetForm extends LoginPasswordService {
    options() {
        return;
    }

    render() {
        return (
            <React.Fragment>
                <Form.Field>
                    <div className="inputLabel">
                        <Trans i18nKey="ticket.webservice.form.ticketnet_account_type">Ticketnet account type</Trans>
                    </div>
                    <Select
                        value={this.state.account_type}
                        disabled={this.props.subscription.account_type}
                        onChange={(synth, { value }) => this.setField('account_type', value)}
                        options={TicketnetForm.options}
                    />
                </Form.Field>
                {this.loginPasswordFields()}
            </React.Fragment>
        );
    }
}

TicketnetForm.options = [
    {
        text: 'Dist',
        value: 'dist'
    },
    {
        text: 'Prod',
        value: 'prod'
    },
    {
        text: 'Single Prod',
        value: 'single_prod'
    },
    {
        text: 'Stades',
        value: 'stades'
    },
    {
        text: 'Billet Stock',
        value: 'stock'
    }
];

export class PlaypassForm extends WebServiceForm {
    options() {
        return;
    }

    render() {
        return (
            <React.Fragment>
                <Form.Field>
                    <div className="inputLabel">Tenant</div>
                    <Input value={this.state.tenant} disabled={this.props.subscription.tenant !== undefined} onChange={event => this.setField('tenant', event.target.value)} />
                </Form.Field>
                <Form.Field>
                    <div className="inputLabel">Access ID</div>
                    <Input value={this.state.login} disabled={this.props.subscription.login !== undefined} onChange={event => this.setField('login', event.target.value)} />
                </Form.Field>
                <Form.Field>
                    <div className="inputLabel">Secret Key</div>
                    <Input value={this.state.password} type="password" onChange={event => this.setField('password', event.target.value)} />
                </Form.Field>
                <Form.Field>
                    <div className="inputLabel">Playpass Server</div>
                    <Select
                        value={this.state.getin_url}
                        disabled={this.props.subscription.getin_url}
                        onChange={(synth, { value }) => this.setField('getin_url', value)}
                        options={PlaypassForm.options}
                    />
                </Form.Field>
            </React.Fragment>
        );
    }
}

PlaypassForm.options = [
    {
        text: 'Production',
        value: 'https://getin.playpass.eu'
    },
    {
        text: 'Demo',
        value: 'https://getin.demo.playpass.eu'
    },
    {
        text: 'Edge',
        value: 'https://getin.edge.playpass.eu'
    }
];
